import { WikiController } from "./wiki/wiki-controller";
import type { loadWikiPage } from "./wiki/wiki.data";

type WikiData = Awaited<ReturnType<typeof loadWikiPage>>;

export function WikiPage({ data }: { readonly data: WikiData }) {
  return (
    <WikiController
      key={`${data.room.forumSlug}/${data.pageSlug}`}
      coworld={data.room.coworld}
      wikiSlug={data.room.forumSlug}
      pageSlug={data.pageSlug}
      initialPage={data.page}
      initialMissing={data.missing}
      initialDataUpdatedAt={data.initialDataUpdatedAt}
      basePath={data.room.wikiBasePath}
    />
  );
}
